import { render } from "./Unsubscribe.vue?vue&type=template&id=eb6881ce"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts"
script.render = render

export default script